<template>
  <div class="pa-park-character-list-banner">
    <ul>
      <li v-for="character in characterList" :key="character.id">
        <CharacterIcon :character="character" />
      </li>
    </ul>
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

import {GetParkCharacterListData} from '@/graphql/queries/Park.graphql'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  props : {
    parkId  : {
      default: null
    }
  },

  components : {
    CharacterIcon
  },

  data(){
    return {
      isParkClipped : false,

      characterList : []
    };
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    parkCharacterList : {
      query : GetParkCharacterListData,

      variables(){
        return {
          park_id : this.parkId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    park  : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data !== null){
          this.isParkClipped = data.is_clipped;
        }
      },
      immediate: true,
      deep: true
    },

    isParkClipped : {
      handler(newValue, oldValue){
        if(newValue !== oldValue){
          this.characterList = [];

          this.$apollo.queries.parkCharacterList.refetch();
        }
      }
    },

    parkCharacterList : {
      handler(data){
        if(typeof data === 'undefined') return;

        for(let i = 0; i < data.data.length; i++){
          let couldRegist = true;

          for(let i2 = 0; i2 < this.characterList.length; i2++){
            if(typeof this.characterList[i2] === 'undefined') continue;
            if(typeof data.data[i].character === 'undefined') continue;

            if(this.characterList[i2].id === data.data[i].character.id){
              couldRegist = false;
              break;
            }
          }

          if(couldRegist === true){
            if(typeof data.data[i].character !== 'undefined'){
              this.characterList.push(data.data[i].character);
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.pa-park-character-list-banner{
  background-color:#CCAA8B;
  border-radius: 8px;
  padding:.3rem;

  ul{
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y:hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    li{
      padding:0 .6rem 0 0;

      &:first-child{
        padding-left:.6rem;
      }

      &:last-child{
        padding-right:.6rem;
      }

      .pa-character-icon{
        background-color:#C4A27A;
        width:3rem;
        height:3rem;
        line-height: 2.8rem;
      }
      
      img, svg{
        width:3rem;
      }
    }
  }
}
</style>